export const HOME = "/";
export const ABOUT = "/about-us";
export const CONTACT = "/contact-us";
export const SERVICES = "/services";
export const CONTAINERS = "/containers";
export const COLLECTION_POINTS = "/collection-points";

export const DASHBOARD = "/dashboard";
export const OBJECTIVES = "/objectives";
export const INDICATORS = "/indicators";
export const REPORTS = "/reports";
export const SETTINGS = "/settings";


export const BACKEND_BASE_URL = "";
